import React from 'react';
import {connect} from 'react-redux';
import {t} from '../../../components/Translate';
import Tooltip from '../Tooltip';
import './styles.css';

/* the backend answers with a month number; these are the words for it */
const MONTH_KEYS = [
    'january', 'february', 'march', 'april', 'may', 'june',
    'july', 'august', 'september', 'october', 'november', 'december',
];

/*
 * Operator of the month, worn.
 *
 * The award was decided once a month and shown on the manager's dashboard, where
 * the person who won it had no reason to look - and by the next month it was
 * somebody else's name there, with nothing to say it had ever been theirs. An
 * award nobody carries is a line in a report.
 *
 * Draws what it is given and fetches nothing, because it is read in two places
 * that know different things: the header, where an operator sees their own, and
 * the profile drawer, where a manager sees somebody else's. One drawing, two
 * callers - the alternative was two medals that drift apart.
 *
 * Which is also why the tooltip names the title rather than the person. It said
 * "you were operator of the month" and that is only true in the header; in the
 * profile it was telling an admin about their own month.
 *
 * One medal is the common case and reads as one thing; from two upwards they are
 * counted rather than lined up, because a row of trophies across a header is a
 * different design decision than the one anybody asked for.
 *
 * Nothing at all when there is nothing to show - no empty slot, no grey outline
 * of a medal that might one day be filled.
 *
 * The language comes from the store rather than from a prop: t() reads it off
 * the user and throws without one, and a component that falls over when a caller
 * forgets an argument is a component that will fall over.
 */
const AwardMedal = ({awards, user, className = ''}) => {
    if (!awards || !awards.length) return null;

    /*
     * Every month, spelled out, in one tooltip. The alternative was a tooltip
     * per medal, which means hovering four times to read four lines.
     */
    const months = awards
        .map(award => {
            const month = t({text: MONTH_KEYS[award.month - 1], user});
            return `${month} ${award.year}`.trim();
        })
        .join(', ');

    const title = `${t({text: 'awardMedalTooltip', user})} ${months}`;

    return (
        <Tooltip text={title} needTranslate={false}>
            <span className={'award-medal ' + className} aria-label={title}>
                <span className="award-medal__mark" aria-hidden="true">🏆</span>
                {awards.length > 1 && (
                    <span className="award-medal__count">{awards.length}</span>
                )}
            </span>
        </Tooltip>
    );
};

const mapStateToProps = state => ({
    user: state.user,
});

export default connect(mapStateToProps)(AwardMedal);



// WEBPACK FOOTER //
// ./src/components-new/general/AwardMedal/index.jsx